"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getDefaultCacheConfig = exports.getDefaultRetrieveCallback = exports.getDefaultUnionCallback = exports.unionPinsUseMax = exports.unionPins = void 0;
var getId_1 = require("../src/renderer/getId");
var cacheCore_1 = require("../src/cache/cacheCore");
var LayerDefinition_1 = require("../src/common/interface/LayerDefinition");
var getWithinViewport_1 = require("../src/renderer/getWithinViewport");
var unionPins = function (oldPins, newPins) {
    var oldPinsTable = {};
    oldPins.map(function (it) {
        oldPinsTable[getId_1.getPositionId(it)] = it;
    });
    var newPinsTable = {};
    newPins.map(function (it) {
        newPinsTable[getId_1.getPositionId(it)] = it;
    });
    Object.entries(newPinsTable).map(function (_a) {
        var k = _a[0], v = _a[1];
        oldPinsTable[k] = v;
    });
    return Object.values(oldPinsTable);
};
exports.unionPins = unionPins;
var unionPinsUseMax = function (oldPins, newPins) {
    var oldPinsTable = {};
    oldPins.map(function (it) {
        oldPinsTable[getId_1.getPositionId(it)] = it;
    });
    var newPinsTable = {};
    newPins.map(function (it) {
        newPinsTable[getId_1.getPositionId(it)] = it;
    });
    Object.entries(newPinsTable).map(function (_a) {
        var k = _a[0], v = _a[1];
        if (!oldPinsTable[k]) {
            oldPinsTable[k] = v;
        }
        else if (Number(v.value) > Number(oldPinsTable[k].value)) {
            oldPinsTable[k] = v;
        }
    });
    return Object.values(oldPinsTable);
};
exports.unionPinsUseMax = unionPinsUseMax;
/**
 * Custom logic to handle duplicated pins
 * - For District/ Area Level: It should always use the larger count value
 * - For Building Level: It should replace the old one
 */
var getDefaultUnionCallback = function (layerDefinition) {
    return function (cache, viewport, pins) {
        var _a;
        var cacheKey = cacheCore_1.viewportToKey(viewport, layerDefinition);
        var newUnionPins = [];
        if (cacheKey === "" + LayerDefinition_1.ZoomLevel.DISTRICT || cacheKey === "" + LayerDefinition_1.ZoomLevel.AREA) {
            newUnionPins = unionPinsUseMax((cache[cacheKey] || []), pins);
        }
        else {
            newUnionPins = unionPins((cache[cacheKey] || []), pins);
        }
        return __assign(__assign({}, cache), (_a = {}, _a[cacheKey] = newUnionPins, _a));
    };
};
exports.getDefaultUnionCallback = getDefaultUnionCallback;
/**
 * Custom logic to retrieve pins from cache to optimize performance
 * - For Building Level: Should only show pin in current visible viewport
 * - For Area / District Level: Show pins outside of visible area
 */
var getDefaultRetrieveCallback = function (layerDefinition) {
    return function (cache, viewport) {
        if (!cache)
            return [];
        if (!cacheCore_1.isViewportFull(viewport, layerDefinition)) {
            var viewingViewport = getWithinViewport_1.getExtendedViewport(viewport);
            var viewportPins = cacheCore_1.getPinsFromCache(cache, viewport, layerDefinition);
            return getWithinViewport_1.getWithinViewport(viewportPins, viewingViewport);
        }
        return cacheCore_1.getPinsFromCache(cache, viewport, layerDefinition);
    };
};
exports.getDefaultRetrieveCallback = getDefaultRetrieveCallback;
var getDefaultCacheConfig = function (layerDefinition) { return ({
    unionCallback: getDefaultUnionCallback(layerDefinition),
    retrieveCallback: getDefaultRetrieveCallback(layerDefinition)
}); };
exports.getDefaultCacheConfig = getDefaultCacheConfig;
